import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0321f9fe"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "pdf-document-header" }
const _hoisted_2 = { class: "pdf-document-header__unit" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { class: "pdf-document-header__label" }
const _hoisted_6 = {
  key: 0,
  class: "pdf-document-header__motto"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "pdf-document-header__motto-title" }, " CỘNG HÒA XÃ HỘI CHỦ NGHĨA VIỆT NAM ", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "pdf-document-header__motto-subtitle" }, " Độc lập - Tự do - Hạnh phúc ", -1))
const _hoisted_9 = [
  _hoisted_7,
  _hoisted_8
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.unitLines, (line, index) => {
        return (_openBlock(), _createElementBlock("p", {
          key: index,
          class: _normalizeClass(["pdf-document-header__line", {
          'pdf-document-header__line--value-only': line.valueOnly,
          'pdf-document-header__line--bold': line.bold,
        }])
        }, [
          (line.valueOnly)
            ? (_openBlock(), _createElementBlock("strong", _hoisted_3, _toDisplayString(line.value), 1))
            : (line.bold)
              ? (_openBlock(), _createElementBlock("strong", _hoisted_4, _toDisplayString(line.label) + ": " + _toDisplayString(line.value), 1))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                  _createElementVNode("strong", _hoisted_5, _toDisplayString(line.label) + ":", 1),
                  _createTextVNode(" " + _toDisplayString(line.value), 1)
                ], 64))
        ], 2))
      }), 128))
    ]),
    (_ctx.showNationalMotto)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, _hoisted_9))
      : _createCommentVNode("", true)
  ]))
}